import React, { Component } from "react";
import "./assets/css/TemplateDesign.css";
import {
  AiOutlineBarcode,
} from 'react-icons/ai';

export default class LeftImbarcodeFields extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imbarcode_component: props.myProps,
    };
  }

  onTrigger = (event) => {
    this.props.parentAddImbarcode();
    event.preventDefault();
  };

  render() {
    return (
      <div className="template-fill-menu-item">
        <button
          className="menu-item-btn"
          value="Add Custom Imbarcode"
          onClick={this.onTrigger}
        >
          <div className='menu-item'>
            <span className='icon'><AiOutlineBarcode /></span>
            <span className='name'>Add Imbarcode</span>
          </div>
          
        </button>
      </div>
    );
  }
}
